import RenderManager from "../rendering/render-manager";
import Utils from "../utils";
import * as Events from "../utils/events";
import EntranceExit from "./EntranceExit";
import Base2DElement from "./base-2d-element";
import Transition from "./Transition";

class SliderScript extends Base2DElement {
    get type2d() { return "SliderScript"; }

    _createContainer() {
        return super._createContainer();
    }

    _initDefaultVars() {
        super._initDefaultVars();
        this._draggable = true;
    }

    get draggable() { return this._draggable; }
    set draggable(val) { this._draggable = val; }

    _initValues(options) {

    }

    constructor(options, parentLayer, uuid) {
        super(options, parentLayer, uuid);

        if (Q3.isReady) {
            this.enterExitCtrl = new EntranceExit(this, [this.domElement]);
            this.enterExitCtrl.init(options);
        } else {
            Q3.Events.listen("tourReady", () => {
                this.enterExitCtrl = new EntranceExit(this, [this.domElement]);
                this.enterExitCtrl.init(options);
                this.evaluateScripts();
            })
        }
        this._code = options.sliderScript || "";
        this.sliderScriptName = options.sliderScriptName || "";
        this._name = this.parentLayer.name || "";
        this.sliderValues = {};

        this.evaluateScripts = this.evaluateScripts.bind(this);
        this.redraw = this.redraw.bind(this);

        this.handleListeners(true);

    }

    get name() {
        return this._name
    }

    get code() {
        return this._code;
    }

    set code(val) {
        this._code = val;
        this.data.sliderScript = val;
    }
    set name(val) {
        this._name = val;
        Q3.data.layers.layers2D[this.parentLayer.uuid].name = val;
        Q3.layers.list[this.parentLayer.uuid].name = val
    }

    getScriptValue(){
        const getSlider = uuid => this.sliderValues[uuid] ? this.sliderValues[uuid] : 0;
        let val = 0;
        let ev;
        try {
            ev = eval(this.code);
            if (typeof ev === 'string') {
                val = ev
            } else {
                val = Math.round(parseFloat(ev) * 100) / 100
            }
        } catch (e) {
            console.warn("Error in slider script: " + e.message);
            console.warn(this.code);
        }
        return val;
    }

    evaluateScripts(data) {
        if (data) {
            this.sliderValues[data.uuid] = data.value;
        }
        let scriptEls = document.querySelectorAll('.q3-text [data-uuid="' + this.parentLayer.uuid + '"]')
        scriptEls.forEach(scriptEl => {
            scriptEl.innerHTML = this.getScriptValue();
        })
        if (Q3.editMode) {
            let scriptEls = document.querySelectorAll('.note-editable [data-uuid="' + this.parentLayer.uuid + '"]')
            scriptEls.forEach(scriptEl => {
                scriptEl.innerHTML = this.parentLayer.name;
            })
        }
    }


    handleListeners(add) {
        Events[add ? "listen" : "unlisten"]("layersCreated", this.evaluateScripts);
        Events[add ? "listen" : "unlisten"]("slidermoved", this.evaluateScripts);
    }

    playLeavingAnimation() {
        this.enterExitCtrl.playLeave();
    }

    cancelLeavingAnimation() {
        this.enterExitCtrl.cancelLeave();
    }

    render() {

    }

    redraw() {

    }

    delete() {

        this.handleListeners(false);

        this.parentLayer.objects.splice(this.parentLayer.objects.indexOf(this), 1);
        this.parentLayer.domElement.removeChild(this.domElement);

        delete this.domElement;

        if (Q3.selected === this) {
            Q3.selected = null;
            Events.fire('selectchange');
        }

    }

}

export default SliderScript;
export { SliderScript };
